const Map = () => import('@/views/overview/Map.vue')
const Index = () => import('@/views/overview/Index.vue')
export default [{
  path: '/overview',
  meta: {
    title: '项目总览',
    activeMenu: '/home/board'
  },
  components: {
    right: Index,
    default: Map
  }
}]
